export { default as NextContentfulImage } from "./NextContentfulImage";
export type {
  NextContentfulImageProps,
  NextContentfulLoaderProps,
} from "./NextContentfulImage.interfaces";
